import type { Control } from 'react-hook-form';
import { Controller } from 'react-hook-form';

import type { TextFieldProps } from '@mui/material';
import { TextField as MuiTextField } from '@mui/material';

type Props = TextFieldProps & {
  control: Control<any>;
  name: string;
};

export default function TextField({
  control,
  name,
  variant = 'outlined',
  ...textFieldProps
}: Props) {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => (
        <MuiTextField
          variant={variant}
          value={field.value}
          onChange={({ target: { value } }) => {
            field.onChange(value);
          }}
          error={!!fieldState?.error?.type}
          helperText={fieldState?.error?.message}
          fullWidth
          size="small"
          inputRef={field.ref}
          {...textFieldProps}
        />
      )}
    />
  );
}
